// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: #343a40;
  text-align: center;
  font-family: GeneralFont;
}

.not-found-content {
  max-width: 600px;
  padding: 20px;
  border-radius: 8px;
}

.not-found-title {
  font-size: 96px;
  margin: 0;
  color: #8e2d8e;
}

.not-found-message {
  font-size: 24px;
  margin: 20px 0;
}

.not-found-link {
  display: inline-block;
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #5c005c;
  color: white;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s ease;
}

.not-found-link:hover {
  background-color: #5c005c;
}`, "",{"version":3,"sources":["webpack://./src/components/not-found/notFound.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EAEA,cAAA;EACA,kBAAA;EACA,wBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;AAAF;;AAIA;EACE,eAAA;EACA,SAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;AADF;;AAIA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,sCAAA;AADF;;AAIA;EACE,yBAAA;AADF","sourcesContent":[".not-found-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n\n  color: #343a40; \n  text-align: center; \n  font-family: GeneralFont;\n}\n\n.not-found-content {\n  max-width: 600px;\n  padding: 20px; \n  border-radius: 8px; \n\n}\n\n.not-found-title {\n  font-size: 96px; \n  margin: 0; \n  color: #8e2d8e; \n}\n\n.not-found-message {\n  font-size: 24px; \n  margin: 20px 0; \n}\n\n.not-found-link {\n  display: inline-block; \n  margin-top: 20px; \n  padding: 10px 20px; \n  background-color: #5c005c; \n  color: white; \n  border-radius: 5px; \n  text-decoration: none; \n  transition: background-color 0.3s ease; \n}\n\n.not-found-link:hover {\n  background-color: #5c005c; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
